import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { IUser } from 'src/modules/authentication/interfaces/user.interface';

@Component({
  selector: 'app-waitlist-banner',
  templateUrl: './waitlist-banner.component.html',
  styleUrls: ['./waitlist-banner.component.scss'],
})
export class WaitlistBannerComponent {
  // Shown whenever the backend has flagged the user as waitlisted (no shift demand
  // in their area). Wording is backend-controlled via user.waitlistMessage.
  @Input() user: IUser;

  // 'banner' — compact inline notice; 'card' — full empty-state that replaces
  // content (e.g. the available shifts list on home when there is no demand at all)
  @Input() displayStyle: 'banner' | 'card' = 'banner';

  constructor(private router: Router) {}

  continueOnboarding() {
    this.router.navigateByUrl('/onboarding-staffer/onboarding-dashboard');
  }
}
